import React from 'react'
import { Link } from 'react-router-dom'
import { t } from '../i18n'
import FollowButton from './FollowButton'
import { ChevronRight } from './Icons'

const topicItem = (topic) => ({ slug: topic.slug, title: topic.title })

/* One topic in a list: rank, name, "N vijesti", optional "+ Prati". The row
   opens the topic; the button only follows (spec 5.9). entry / followEntry:
   how analytics names the two (topic_open, topic_follow). */
export function TopicRow({ topic, rank, follow = false, entry, followEntry = entry }) {
  return (
    <li className="topic-row">
      <Link to={`/tema/${topic.slug}`} state={{ entry }} className="topic-row-link">
        {rank != null && <span className="topic-rank">{rank}</span>}
        <span className="topic-row-text">
          <span className="topic-row-name">{topic.shortTitle || topic.title}</span>
          <span className="topic-row-meta">
            {t('trending.stories', { count: topic.articleCount ?? topic.storyCount })}
          </span>
        </span>
        {!follow && <ChevronRight size={16} className="muted-icon" />}
      </Link>
      {follow && (
        <FollowButton kind="topic" item={topicItem(topic)} variant="list" entry={followEntry} />
      )}
    </li>
  )
}

/* "Aktuelne teme" in the desktop right column: top 5, rank, name, count. */
export function TrendingList({ topics, title }) {
  if (!topics.length) return null
  return (
    <section className="rail-box">
      <h2 className="section-title">{title || t('trending.title')}</h2>
      <ol className="topic-list">
        {topics.map((topic, i) => (
          <TopicRow key={topic.slug} topic={topic} rank={i + 1} entry="trending_block" />
        ))}
      </ol>
      <Link to="/istrazi?teme=sve" className="link-orange rail-more">
        {t('trending.allTopics')}
        <ChevronRight size={16} strokeWidth={2.5} />
      </Link>
    </section>
  )
}

/* Mobile web: the block right under the Glavna novost (spec 7.3). */
export function TrendingBlock({ topics, title }) {
  if (!topics.length) return null
  return (
    <section className="feed-item trending-block">
      <div className="trending-block-head">
        <h2 className="section-title">{title || t('trending.title')}</h2>
        <Link to="/istrazi?teme=sve" className="link-orange">
          {t('trending.allTopics')}
          <ChevronRight size={16} strokeWidth={2.5} />
        </Link>
      </div>
      <ol className="trending-cards">
        {topics.map((topic, i) => (
          <li key={topic.slug}>
            <Link
              to={`/tema/${topic.slug}`}
              state={{ entry: 'trending_block' }}
              className="trending-card"
            >
              <span className="trending-card-top">
                <span className="topic-rank">{i + 1}</span>
                <span className="trending-badge">
                  <span className="topic-dot" aria-hidden="true" />
                  {t('trending.badge')}
                </span>
              </span>
              <span className="trending-card-name">{topic.shortTitle || topic.title}</span>
              <span className="topic-row-meta">
                {t('trending.stories', { count: topic.articleCount ?? topic.storyCount })}
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  )
}
